import React from 'react';
import PropTypes from 'prop-types';
const Tag = (props) => {
    let { name } = props;
    return (React.createElement("div", { className: `badge badge-light border` },
        React.createElement("span", { className: "text-info" }, name)));
};
Tag.propTypes = {
    name: PropTypes.string,
};
export default Tag;
